export const pageContentClass = 'mx-auto w-full max-w-[760px] pb-6';
export const responsiveGridClass = 'grid grid-cols-1 gap-3 sm:grid-cols-2';
